import type {RouteParams} from 'types/routes'
import {WITHOUT_AUTH_PATHS} from 'consts/paths'
import {Show} from 'pages/withoutAuth/changeEmailConfirmation/show'

export const ChangeEmailConfirmationRoutes: RouteParams[] = [
  {
    key: 'change_email_confirmation',
    path: WITHOUT_AUTH_PATHS.CHANGE_EMAIL_CONFIRMATION.SHOW,
    component: Show,
    exact: true,
    whiteList: [],
  },
]
